import { render, staticRenderFns } from "./CustomCourseModal.vue?vue&type=template&id=90b4614a&scoped=true"
import script from "./CustomCourseModal.vue?vue&type=script&lang=js"
export * from "./CustomCourseModal.vue?vue&type=script&lang=js"
import style0 from "./CustomCourseModal.vue?vue&type=style&index=0&id=90b4614a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b4614a",
  null
  
)

export default component.exports